module.exports = __webpack_public_path__ + "static/media/barchart.a42b4877.PNG";